module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal c-modal--reward-order t-modal is-visible"
  }, [_c('section', {
    staticClass: "c-modal__box c-modal--reward-order__box"
  }, [(_vm.orderErrorMessage !== null && typeof _vm.orderErrorMessage === 'object') ? _c('div', {
    staticClass: "c-modal--reward-order__box__content"
  }, [_c('h1', {
    staticClass: "c-modal--reward-order__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_error.error_title', {
    error_code: _vm.orderErrorMessage.code
  })))]), _vm._v(" "), _c('p', {
    staticClass: "c-modal--reward-order__error-message u-paragraph u-center-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('web.catalog_order_error.error_message', {
    reason: _vm.$t(_vm.orderErrorMessage.reason),
    detail: _vm.$t(_vm.orderErrorMessage.detail.order)
  })))])])]) : _c('div', {
    staticClass: "c-modal--reward-order__box__content"
  }, [_c('h1', {
    staticClass: "c-modal--reward-order__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_error.error_title_no_code')))]), _vm._v(" "), _c('p', {
    staticClass: "c-modal--reward-order__error-message u-paragraph u-center-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.orderErrorMessage))])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__actions"
  }, [_c('button', {
    staticClass: "c-button\n               c-modal--reward-order__actions__button\n               c-modal--reward-order__actions__button--full-width\n               t-button-plain",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_order_error.back_button')) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__overlay"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e8555ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/OrderError.vue
// module id = 520
// module chunks = 1